import { getStoreInfo } from './api';

export interface TicketSettings {
  storeName: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
  };
  footerMessage: string;
}

export const getTicketSettings = async (): Promise<TicketSettings> => {
  const storeInfo = getStoreInfo();
  if (!storeInfo) {
    throw new Error('Store information not available');
  }

  // Split address into components
  const addressParts = storeInfo.address.split(',');
  const street = addressParts[0]?.trim() || '';
  const city = addressParts[1]?.trim() || '';
  const state = 'Hauts-de-France'; // Default value
  const zipCode = addressParts[2]?.trim() || '';

  return {
    storeName: storeInfo.name,
    address: {
      street,
      city,
      state,
      zipCode
    },
    footerMessage: "Merci de votre commande ! À bientôt !"
  };
};